import React from 'react'
import {Component} from 'react'
import { ReactSVG } from 'react-svg'
import './index.css'

export class SocialLink extends Component { 
    render() {
        return(
        <div className='nanoSocialLink'>
            <a href={this.props.nUrl} target="_blank" rel="noreferrer">
                <ReactSVG src={this.props.nImage} />
            </a>
        </div>
        );
    }

    componentDidMount() {
        // dom node created
    }

    componentWillUnmount () {
        // dom node deleted
    }

    componentDidUpdate(previousProps, previousState) {
        
    }
}
